import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useFieldControl } from "./Field.js";
const Textarea = React.forwardRef(function Textarea2(props, ref) {
  const { className, ...rest } = useFieldControl(props);
  return /* @__PURE__ */ jsx("textarea", { ref, className: cx("ev-textarea", className), ...rest });
});
Textarea.displayName = "Textarea";
export {
  Textarea
};
//# sourceMappingURL=Textarea.js.map
